export default "__VITE_ASSET__Bd$v4RG$__"